import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import ApiEndPoints from "../components/common/ApiEndpoints";
import Cookies from "js-cookie";
import useNotification from "../components/common/Notification";
import base_url from "../constants";
// import { jwtDecode } from "jwt-decode";

// Create AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [companyLogo, setCompanyLogo] = useState("");
    const [authChecked, setAuthChecked] = useState(false);
    const notify = useNotification();

    const api = axios.create({
        baseURL: "http://localhost:5000/api", // Change to your backend URL
        withCredentials: true, // Ensure cookies are sent with requests
    });

    // Fetch user data when the app loads
    useEffect(() => {
        checkAuthStatus();
    }, []);

    // Function to check authentication status
    const checkAuthStatus = async () => {
        try {
            const token = Cookies.get("token");
            if (token) {
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
            }
            // setUser(res.data.user);
        } catch (error) {
            // setUser(null);
            Cookies.remove("token");
            setIsLoggedIn(false);
        } finally {
            // setLoading(false);
            setAuthChecked(true);
        }
    };

    // Function to login
    const register = async (credentials) => {
        try {
            const res = await ApiEndPoints.register(credentials);
            console.log(res.data);
        } catch (e) {
            console.log("Error: ", e);
        }
    };
    const login = async (credentials) => {
        try {
            const res = await ApiEndPoints.login(credentials);
            await completeLogin(res.data);
        } catch (error) {
            console.error("Login failed", error.response?.data?.message);
            throw error;
        }
    };

    const loginWithGoogle = async (credential) => {
        try {
            const res = await ApiEndPoints.googleLogin(credential);
            await completeLogin(res.data);
        } catch (error) {
            console.error("Google login failed", error.response?.data?.message);
            throw error;
        }
    };

    const completeLogin = async (data) => {
        const token = data.token;
        Cookies.set("token", token);
        Cookies.set("userId", JSON.stringify(data.userid));
        const userRolResp = await axios.get(
            `${base_url}/whatsapp/personal/get/user_role/v1/${data.userid}`
        );
        console.log("userRole: ", userRolResp.data.data[0]);
        setUserRole(userRolResp.data.data[0].user_role);
        if(userRolResp.data.data[0].p_whatsapp_subscription_end != null ) {
        Cookies.set("pwse", userRolResp.data.data[0].p_whatsapp_subscription_end);

        } 
        if(userRolResp.data.data[0].email_subscription_end != null ) {
        Cookies.set("bese", userRolResp.data.data[0].email_subscription_end);
        }
        if(userRolResp.data.data[0].business_whatsapp_subscription_end != null ) {
        Cookies.set("bwse", userRolResp.data.data[0].business_whatsapp_subscription_end);
        }

        const logo = userRolResp.data.data[0]?.business_logo;
        if (logo) {
            Cookies.set("logo", logo);
        }

        setCompanyLogo(userRolResp.data.data[0]?.business_logo);

        Cookies.set("userRole", userRolResp.data.data[0].user_role);

        const userName = data?.name || userRolResp.data?.data?.[0]?.name || "";
        if (userName) Cookies.set("userName", userName);

        setIsLoggedIn(true);
    };

    const subscriptionStatus = async () => {

        try {
            const userId = Cookies.get("userId");
            const userRolResp = await axios.get(
                `${base_url}/whatsapp/personal/get/user_role/v1/${userId}`
            );
            console.log("userRole: ", userRolResp.data.data[0]);
            setUserRole(userRolResp.data.data[0].user_role);
            if(userRolResp.data.data[0].p_whatsapp_subscription_end != null ) {
            Cookies.set("pwse", userRolResp.data.data[0].p_whatsapp_subscription_end);

            } 
            if(userRolResp.data.data[0].email_subscription_end != null ) {
            Cookies.set("bese", userRolResp.data.data[0].email_subscription_end);
            }
            if(userRolResp.data.data[0].business_whatsapp_subscription_end != null ) {
            Cookies.set("bwse", userRolResp.data.data[0].business_whatsapp_subscription_end);
            }
            const userName = userRolResp.data?.data?.[0]?.name || "";
            if (userName) Cookies.set("userName", userName);

        }catch(error) {

            console.error("Subscription status fetch failed", error.response?.data?.message);
            throw error;

        }

    }


    // Function to logout
    const logout = async () => {
        try {
            // Clear all cookies
            const allCookies = Cookies.get();
            Object.keys(allCookies).forEach((cookieName) => {
                Cookies.remove(cookieName);
            });

            // Clear localStorage
            localStorage.clear();

            // Update state
            setIsLoggedIn(false);
            setUserRole(null);
            setCompanyLogo("");
            // setUser(null);
        } catch (error) {
            console.error("Logout failed", error.response?.data?.message);
            // Even if there's an error, try to clear cookies and state
            const allCookies = Cookies.get();
            Object.keys(allCookies).forEach((cookieName) => {
                Cookies.remove(cookieName);
            });
            localStorage.clear();
            setIsLoggedIn(false);
            setUserRole(null);
            setCompanyLogo("");
        }
    };

    return (
        <AuthContext.Provider
            value={{
                isLoggedIn,
                loading,
                login,
                loginWithGoogle,
                logout,
                register,
                checkAuthStatus,
                subscriptionStatus,
                authChecked,
                userRole,
                companyLogo,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use auth context
export const useAuth = () => useContext(AuthContext);
